import React, { lazy, Suspense } from 'react';
import Grid from '@mui/material/Grid';
import OurValues from './OurValues';
import OurPeople from './OurPeople';
import About from './About';
import SelectionProcessSteps from './SelectionProcessSteps';
import FingoCircularProgressLoader from '../../components/loader/FingoCircularProgressLoader';

const BizneoWidget = lazy(() => import(/* webpackChunkName: "bizneo-widget" */ './BizneoWidget'));

function Team() {
  return (
    <Grid>
      <OurValues />
      <OurPeople />
      <About />
      <SelectionProcessSteps />
      <Suspense fallback={<FingoCircularProgressLoader />}>
        <BizneoWidget />
      </Suspense>
    </Grid>
  );
}

export default Team;
